<template>
  <v-container fluid>
    <v-row class="justify-center">
      <v-col md="6" sm="12">
        <form @submit.prevent="save">
          <v-card>
            <v-toolbar flat color="primary">
              <v-toolbar-title>Team Details</v-toolbar-title>
              <v-spacer />
            </v-toolbar>
            <v-card-title primary-title>
              <v-list-item two-line>
                <v-list-item-avatar>
                  <v-img :src="user.profile_photo_url" aspect-ratio="1" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ user.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ user.email }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card-title>
            <v-card-text>
              <v-text-field
                v-model="form.name"
                label="Team Name"
                required
                class="form-control"
                type="name"
                name="name"
                :class="{ 'is-invalid': form.errors.name }"
                :error="form.errors.name"
                :error-messages="form.errors.name"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                type="submit"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'

export default {
   metaInfo: { title: 'Settings' },
   layout: (h, page) => h(Layout, [page]),
   props: {
      user: {
         type: Object,
         required: true
      }
   },
   data () {
      return {
         form: this.$inertia.form({
            name: '',
         })
      }
   },

   methods: {
      save () {
         this.form.post(this.route('teams.store'), {
            preserveScroll: true
         })
      },
   },
}
</script>

<style>

</style>
